let OSS = require('ali-oss')
export let client  = new OSS({
  region: 'oss-cn-hangzhou',//节点
  accessKeyId: 'LTAI5t7u8eECWfr85YSz7RXF',
  accessKeySecret: 'zpLQSoug2qGGmKwn4Y1XlmKspBYGiq',
  bucket: 'ng-association-system'
})